module.exports = __webpack_public_path__ + "static/media/Liz Shawen Headshot.7c7eb702.jpeg";